export default __webpack_public_path__ + "static/polartr-d000a80855290f1b8dc10feb5649dbd2.png";